import React, { useMemo } from 'react';
import { Dialog, DialogActions, Button } from '@material-ui/core';
import { DataGrid } from '@mui/x-data-grid';
import { Stack } from '@mui/material';

import { ReactComponent as NoDocumentIcon } from '../../assets/images/no-document.svg';
import useStyles from './styles';

const ClientsList = (props) => {
	const classes = useStyles();

	const columns = useMemo(() => [
		{
			field: "id",
			headerName: "Sr. No.",
			sortable: false,
			flex: 1,
			headerAlign: "center",
			align: "center",
			minWidth: 100,
			renderCell: (params) => (
				<div className={classes.row}>
					<span className={classes.overflowText}>
						{params.row.id}
					</span>
				</div>
			),
		},
		{
			field: "name",
			headerName: "Clients",
			sortable: false,
			flex: 1,
			headerAlign: "center",
			align: "center",
			minWidth: 100,
			renderCell: (params) => (
				<div className={classes.row}>
					<span className={classes.overflowText}>
						{params.row.name}
					</span>
				</div>
			),
		}
	], []);

	const emptyTableMessage = useMemo(() => (
		<Stack
			height="100%"
			alignItems="center"
			justifyContent="center"
			className={classes.emptyDataText}
		>
			No Documents To show.
			<NoDocumentIcon className={classes.noDocumentIcon} />
		</Stack>
	), [classes.emptyDataText]);

	return (
		<Dialog open={props.show}>
			<div className={classes.clientsList}>
				<DataGrid
					disableRowSelectionOnClick
					className={classes.table}
					rows={props.data}
					columns={columns}
					sx={{
						maxHeight: '100%',
						overflowX: 'auto',
						'.MuiDataGrid-selectedRowCount': {
							visibility: 'hidden'
						},
						'& .MuiDataGrid-virtualScrollerContent': {
							height: '100% !important',
							width: '100% !important',
							marginTop: '0px !important'
						},
					}}
					getRowId={(row) => row.id}
					components={{
						NoRowsOverlay: () => emptyTableMessage,
						NoResultsOverlay: () => emptyTableMessage

					}}
					filterMode="server"
					disableColumnMenu
					hideFooter
				/>
			</div>

			<DialogActions>
				<Button autoFocus onClick={props.handleClose}>
					Close
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default ClientsList;